import { useEffect, useState } from "react"
import { dashBoard } from "../../../shared/services/services"
import { DashboardData } from "../../../shared/services/interface"

const useDashboard = (from?: string, to?: string) => {
    const [dashboard, setDashboard] = useState<DashboardData>()
    useEffect(() => {
        dashBoard(from, to)
            .then((res) => { setDashboard(res.data) })
            .catch((error) => console.error(error))
    }, [from, to])
    return { dashboard }
}

export default useDashboard;